module.exports = __webpack_public_path__ + "static/img/price-bg.330440a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/price-bg.png
// module id = a1w3
// module chunks = 0